export default {
  sections: {
    order_summary: 'Riepilogo ordine',
  },
  labels: {
    add_items: 'Aggiungi articoli per iniziare',
    item_count_one: '{{count}} articolo',
    item_count_other: '{{count}} articoli',
  },
  buttons: {
    return: 'Torna',
  },
  tip: 'Mancia',
};
